import { Box, Heading } from "@vinomofo/components";
import { InlineTimerDisplay } from "./InlineTimerDisplay";
import { useState } from "react";

interface CountdownTimerProps {
  dateTime?: string;
  title?: string;
  isExpandedDisplay?: boolean;
  textColor?: string;
  size?: "sm" | "md" | "lg";
}

const InlineCountdownTimer = ({
  dateTime,
  title,
  isExpandedDisplay,
  textColor,
  size,
}: CountdownTimerProps) => {
  const [currentDateTime, setCurrentDateTime] = useState(dateTime);

  const handleTimerUpdate = (newDateTime: string) => {
    setCurrentDateTime(newDateTime);
  };

  if (!currentDateTime) {
    return null;
  }

  return (
    <Box
      mb={3}
      padding={["20px", "0px", "0px", "0px"]}
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      {title && (
        <Box mr={2}>
          <Heading
            fontSize={["17px", "24px", "28px"]}
            color={textColor}
            fontWeight="700"
            fontFamily={"heading"}
            lineHeight={["100%", "132%", "132%"]}
            letterSpacing={"-1px"}
          >
            {title}
          </Heading>
        </Box>
      )}
      <InlineTimerDisplay
        dateTime={currentDateTime}
        isExpandedDisplay={isExpandedDisplay}
        size={size}
        onTimerUpdate={handleTimerUpdate}
      />
    </Box>
  );
};

export { InlineCountdownTimer };
